import { gql } from "@apollo/client";

export const HOSTING_PACKAGES = gql`
  query ($limit: Int!, $page: Int!) {
    hosting {
      packages(limit: $limit, page: $page) {
        nodes {
          id
          name
          status
          hosting_package_pricing {
            id
            price
            discount_promo
            package_id
            duration
            reseller_package_pricing {
              id
              reseller_level
              reseller_price
            }
          }
          description {
            id
            package_id
            key
            value
          }
        }
      }
    }
  }
`;

export const HOSTING_DETAIL = gql`
  query ($id: Int!) {
    hosting {
      hosting(id: $id) {
        id
        name
        register_date
        expired_date
        status
        description
        plesk_account_id
        package_name
        plesk_account {
          username
          password
        }
      }
    }
  }
`;

export const AUTO_LOGIN_PLESK = gql`
  mutation ($input: NewCreateSession!) {
    hosting {
      autoLoginOps {
        autoLogin(input: $input)
      }
    }
  }
`;

export const CHECK_DOMAIN = gql`
  mutation ($Domain: String!) {
    domain {
      domainOps {
        checkDomain(Domain: $Domain) {
          code
          domain
          available
          reason
          premium
        }
      }
    }
  }
`;

export const HOSTING_LIST = gql`
  query ($limit: Int!, $page: Int!, $sort: Int) {
    hosting {
      hostings(limit: $limit, page: $page, sort: $sort) {
        page
        total_data
        nodes {
          id
          name
          register_date
          expired_date
          status
          package_name
          plesk_account {
            username
            password
          }
        }
      }
    }
  }
`;

export const HOSTING_RENEW = gql`
  mutation ($input: RenewCloudbankHostingInput!) {
    hosting {
      hosting {
        renew(input: $input)
      }
    }
  }
`;

export const HOSTING_UPGRADE_PACKAGE = gql`
  mutation ($input: UpgradeCloudbankHostingInput!) {
    hosting {
      hosting {
        upgrade(input: $input)
      }
    }
  }
`;
